export const celsiusToFahrenheit = (tempInCelsius) => {
  return roundToDecimals(tempInCelsius * 1.8 + 32, 0);
};

export const meterPerSecondToMPH = (meterPerSecond) => {
  return roundToDecimals(meterPerSecond * 2.23694, 0);
};

const roundToDecimals = (num, places) => {
  return +(Math.round(num + `e+${places}`) + `e-${places}`);
};

export const windDirection = (num) => {
  switch (true) {
    case num >= 11.25 && num < 33.75:
      return 'NNE';
    case num >= 33.75 && num < 56.25:
      return 'ENE';
    case num >= 56.25 && num < 78.75:
      return 'E';
    case num >= 78.75 && num < 101.25:
      return 'ESE';
    case num >= 101.25 && num < 123.75:
      return 'ESE';
    case num >= 123.75 && num < 146.25:
      return 'SSE';
    case num >= 146.25 && num < 168.75:
      return 'SSE';
    case num >= 168.75 && num < 191.25:
      return 'S';
    case num >= 191.25 && num < 213.75:
      return 'SSW';
    case num >= 213.75 && num < 236.25:
      return 'SW';
    case num >= 236.25 && num < 258.75:
      return 'WSW';
    case num >= 258.75 && num < 281.25:
      return 'W';
    case num >= 281.25 && num < 303.75:
      return 'WNW';
    case num >= 303.75 && num < 326.25:
      return 'NW';
    case num >= 326.25 && num < 348.75:
      return 'NNW';
    case num >= 348.75 || num < 11.25:
      return 'N';
    default:
      return '-';
  }
};
